module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/icon_error-19f516fa7f3c3581b708e6fbc98ac0f2.svg";